import React from 'react';
import { Box, makeStyles } from '@popmenu/common-ui';
import type { RootPlacePersonalizedMenuItemsQuery_rootPlace_RootPlace_personalizedMenuItems_MenuItemUserTasteMatchPaginationHandler_records_MenuItemUserTasteMatch as UserTasteMatch } from '~/libs/gql/queries/eat/rootPlacePersonalizedMenuItemsQuery.generated';
import { DishFeedCard } from '../DishFeedCard';
import { RestaurantLinkButton } from '../RestaurantLinkButton';
import { TasteMatchChips } from '../TasteMatchChips';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
}));

type ForYouDishCardProps = {
  dishPathPrefix: string
  userTasteMatch: UserTasteMatch
}

// A feed card with chips for why the dish suits the diner, and its link out to the restaurant
export const ForYouDishCard = ({ dishPathPrefix, userTasteMatch: { menuItem, traits } }: ForYouDishCardProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <DishFeedCard {...menuItem} dishPathPrefix={dishPathPrefix} />
      <TasteMatchChips traits={traits} />
      {menuItem.restaurantLink && (
        <RestaurantLinkButton dishName={menuItem.displayName} link={menuItem.restaurantLink} restaurantName={menuItem.restaurant?.name ?? ''} />
      )}
    </Box>
  );
};
